import DescriptionList from './DescriptionList';
import Description from './Description';

DescriptionList.Description = Description;
export default DescriptionList;



// WEBPACK FOOTER //
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/src/components/DescriptionList/index.js